import colors from '@/../themeConfig.js'

const state = {
  sidebarWidth: 'default',
  theme: 'light',
  themePrimaryColor: colors.primary
}

export default state
